import { render, staticRenderFns } from "./DialogInnerChat.vue?vue&type=template&id=bd0f8c42&scoped=true"
import script from "./DialogInnerChat.vue?vue&type=script&lang=js"
export * from "./DialogInnerChat.vue?vue&type=script&lang=js"
import style0 from "./DialogInnerChat.vue?vue&type=style&index=0&id=bd0f8c42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0f8c42",
  null
  
)

export default component.exports